import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface ProductManagerFilterChipProps {
  selectedProductManagerId?: string
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
  productManagers?: PriceChangeFilterLookupItem[]
}

const ProductManagerFilterChip: React.FC<ProductManagerFilterChipProps> = ({
  selectedProductManagerId,
  onRemove,
  productManagers,
}) => {
  const productManagerName = useMemo(
    () => productManagers?.find((productManager) => productManager.id === selectedProductManagerId)?.label ?? "",
    [selectedProductManagerId, productManagers]
  )

  return (
    <FilterChip
      key='pricing.product-manager-filter-chip'
      data-testid='pricing.product-manager-filter-chip'
      label={`Product Manager: ${productManagerName}`}
      onDelete={() => onRemove("productManagerId", undefined)}
    />
  )
}

export default ProductManagerFilterChip
